module.exports = __webpack_public_path__ + "static/img/picture4.babf528b.png";